import Marquee from "./Marquee";

export default function Testimonials({ items, eyebrow, pre, word, dark = false, testid }) {
  return (
    <section className={`py-16 border-t border-gold/40 ${dark ? "text-ivory" : "text-ink"}`} data-testid={testid}>
      <div className="px-6 lg:px-10 max-w-7xl mx-auto mb-10">
        <p className="eyebrow mb-3">{eyebrow}</p>
        <h2 className="font-display text-3xl lg:text-4xl tracking-tight whitespace-nowrap">{pre} <span className="font-sign text-gold lowercase tracking-normal text-4xl">{word}</span></h2>
      </div>
      <Marquee duration={items.length * 18}>
        {items.map((t) => (
          <figure key={t.n} className="w-[85vw] md:w-[46vw] max-w-[640px] shrink-0 px-6 lg:px-10 border-r border-gold/30">
            <p className="font-sign text-5xl text-gold leading-none mb-2">&ldquo;</p>
            <blockquote className={`font-headline italic text-lg lg:text-xl leading-snug ${dark ? "text-ivory/85" : "text-ink/75"}`}>{t.q}</blockquote>
            <figcaption className="mt-5">
              <p className="font-display tracking-wide">{t.n}</p>
              <p className={`eyebrow !text-[0.55rem] mt-1 ${dark ? "!text-gold" : "!text-ink/50"}`}>{t.r}</p>
            </figcaption>
          </figure>
        ))}
      </Marquee>
    </section>
  );
}
